/**
 * Cash vs debt mix (ADR-0034). Missing legs are null, never 0 (R2b).
 */

export interface CashMix {
  readonly netCash: number | null;
  /** Cash share of cash+debt on [0, 1]. Null when the sum is 0 or a leg is missing. */
  readonly cashShare: number | null;
}

export function cashMix(totalCash: number | null, totalDebt: number | null): CashMix {
  if (totalCash === null || totalDebt === null) return { netCash: null, cashShare: null };
  if (!Number.isFinite(totalCash) || !Number.isFinite(totalDebt)) {
    return { netCash: null, cashShare: null };
  }
  const netCash = totalCash - totalDebt;
  const sum = totalCash + totalDebt;
  if (sum <= 0) return { netCash, cashShare: null };
  const share = totalCash / sum;
  return { netCash, cashShare: Number.isFinite(share) ? share : null };
}
